module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/website-754e87fb4b13b9cdd77e2800a0241b05.png";